import { funnelFlow } from 'funnel/src/app/funnel.flow';
import { FlowExperiment, FunnelFlowConfig, quiz, screen } from 'funnel/src/app/flow/flow-config';

// Both kindle configs list both tests, so cells, exposures and web_ab_* properties read the same
// whichever flow the visitor is on.
const kindleTests: readonly FlowExperiment[] = [
  {
    // Age in gender's place as the second screen. Logged when that screen renders, so visitors
    // who bounce on the first screen stay out of it.
    experiment: 'kindle_second_screen_nov_2026',
    property: 'web_ab_kindle_second_screen',
    exposedOn: ['gender', 'age'],
    cells: { age: [{ replace: 'gender', with: [quiz('age')] }] },
  },
  {
    // In the `main` cell, visitors without Kindle books continue on kindleMainFlow (see
    // KindleFunnelFlowService.isOnMainFlow). Only they are exposed.
    experiment: 'kindle_no_books_flow_nov_2026',
    property: 'web_ab_kindle_no_books_flow',
    exposedWhen: { step: 'hasKindleBooks', is: ['no'] },
  },
];

export const kindleFunnelFlow: FunnelFlowConfig = {
  screens: [
    quiz('hasKindleBooks'),
    quiz('gender'),

    quiz('amountInfo'),

    quiz('timeForReading'),
    quiz('audioExperienceInfo'),

    quiz('goalMotivations'),

    quiz('goalInfo'),

    quiz('personType'),
    quiz('personTypeInfo'),

    quiz('kindleFriction'),

    quiz('visionCare'),
    quiz('visionCareInfo', { skipIf: { step: 'visionCare', is: ['allGood'] } }),

    quiz('time'),

    quiz('audioCustomizationInfo'),
    screen('customization'),

    quiz('nonFictionInterests'),
    quiz('fictionInterests'),

    quiz('celeb1'),
    quiz('celeb2'),
    quiz('celeb3'),

    quiz('book1'),
    quiz('book2'),
    quiz('book3'),
    quiz('yourBook'),

    quiz('listeningTime'),

    quiz('prediction'),
    screen('ready'),
    screen('login'),

    quiz('result'),
    screen('paywall'),
  ],
  experiments: kindleTests,
};

// The kindle funnel's first two screens, then the main funnel's screens after its age and gender.
export const kindleMainFlow: FunnelFlowConfig = {
  screens: [
    quiz('hasKindleBooks'),
    quiz('gender'),
    ...funnelFlow.screens.filter(
      s => !(s.type === 'quiz' && (s.step === 'age' || s.step === 'gender'))
    ),
  ],
  promotedBookPatches: funnelFlow.promotedBookPatches,
  experiments: kindleTests,
};
